import { render, staticRenderFns } from "./UploadBook.vue?vue&type=template&id=10eb5a44"
import script from "./UploadBook.vue?vue&type=script&lang=js"
export * from "./UploadBook.vue?vue&type=script&lang=js"
import style0 from "./UploadBook.vue?vue&type=style&index=0&id=10eb5a44&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports